<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >SiteConf配置</el-button
    >
    <el-dialog
      :visible="dialogVisible"
      title="新增SiteConf配置"
      width="600px"
      @close="closeDialog"
      :before-close="handleClose"
    >
      <el-form :model="detail" ref="form" :rules="rules" label-width="120px">
      
        <el-form-item label="confKey" prop="confKey">
          <el-input
            :controls="false"
            v-model.trim="detail.confKey"
          ></el-input>
        </el-form-item>
      
        <el-form-item label="confValue" prop="confValue">
          <el-input
          type="textarea"
            v-model="detail.confValue"
            :controls="false"
            :min="0"
          ></el-input>
        </el-form-item>
        <el-form-item label="配置说明" prop="confIntroduction">
          <el-input
            type="textarea"
            :rows="3"
            v-model="detail.confIntroduction"
            placeholder="选填：该配置的用途说明"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handleSave('form')">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "PledgeCreate",
  data() {
    return {
      dialogVisible: false,
      detail: {},
      userType: "1",
      lists: [
        { label: "用户账号", value: "1" },
        { label: "用户ID", value: "2" },
      ],
      coinTypes: ["USDT", "SHIB", "BABYDOGE", "ETH"],
      rules: {
        confValue: {
          required: true,
          message: "请填写confValue",
          trigger: "blur",
        },
        confKey: {
          required: true,
          message: "请填写confKey",
          trigger: "blur",
        },
       
      },
    };
  },
  computed: {
    // ...mapState('transferInner', ['coinTypes'])
    ...mapState('ctf',['coinList'])
  },
  mounted() {
    this.listAllCoin()
  },
  methods: {
    ...mapActions("Siteconf", ["create", "transfer",'reqList']),
    ...mapActions('ctf', ['getCtflist', 'listAllCoin']),
    handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
    closeDialog() {
      
      this.dialogVisible = false;
      this.detail = {};
      this.$refs["form"].resetFields();
    },
  
    close() {
      this.dialogVisible = false;
      this.detail = {};
      this.$refs["form"].resetFields();
    },
    handleSave() {
     

      this.$refs["form"].validate(async (valid) => {
        if (valid) {
         const res =await this.create({...this.detail})
            if (res.code == 0) {
              this.$message({
                message: "添加成功！",
                type: "success",
              });
              this.$emit("refresh", {page: 1});
              this.dialogVisible = false;
            }
        }
      });
    },
  },
};
</script>

<style lang="less">
.editor {
  height: 500px;
}
</style>
